import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext, UserContext } from 'commons-ui';

import useService from '../../utils/useService';

const useEditBulk = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const { user } = useContext(UserContext);
	const history = useHistory();
	const location = useLocation();
	const { requestUpdatePartnerCoupon } = useService();

	const data = _get(location, ['state', 'rowData']);

	const updateCoupon = (updatedData: any) => {
		const payload = {
			partnerCollectionId: updatedData.id,
			isDisabled: updatedData.isDisabled
		};

		setShowLoader(true);
		requestUpdatePartnerCoupon(app.appName, { ...payload, updatedBy: _get(user, 'userName', '') }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(`Error: ${res?.data?.error || 'Error occured while editing the bulk of a partner coupon'}`, {
						type: 'error'
					});
					setShowLoader(false);
					return;
				}
				showAlert('Record Updated');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });

				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		updateCoupon(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useEditBulk;
